// extracted by mini-css-extract-plugin
export var wrapper = "newsletter-module--wrapper--bd8oq";
export var cta = "newsletter-module--cta--2G1wA";
export var black = "newsletter-module--black--13Kfz";
export var white = "newsletter-module--white--31JlA";
export var inputContainer = "newsletter-module--inputContainer--MZfTQ";
export var button = "newsletter-module--button--34qWA";